module.exports = __webpack_public_path__ + "static/media/sedimentosBGP.139aaa5e.pdf";